import styled from "styled-components"
import { Tabs as ReactTabs } from "react-tabs"
import Color from "../../../style/enum/color"

export const Tabs = styled(ReactTabs)`
  .react-tabs__tab-list {
    display: flex;
    margin: 0 0 10px;
    padding: 0;
    color: ${Color.DIMGRAY};
    font-weight: 400;
  }

  .react-tabs__tab {
    list-style: none;
    cursor: pointer;
    flex-grow: 1;
    text-align: center;
    border-bottom: 1px solid ${Color.LIGHT_GRAY};
    transition: 0.3s;
    min-height: 44px;
    line-height: 3;
  }

  .react-tabs__tab--selected {
    color: ${Color.BRAND};
    border-bottom: 2px solid ${Color.BRAND};
  }

  .react-tabs__tab--disabled {
    color: GrayText;
    cursor: default;
  }

  .react-tabs__tab:focus {
  }

  .react-tabs__tab:focus:after {
    content: "";
    position: absolute;
    height: 5px;
    left: -4px;
    right: -4px;
    bottom: -5px;
    background: ${Color.WHITE};
  }

  .react-tabs__tab-panel {
    display: none;
  }

  .react-tabs__tab-panel--selected {
    display: block;
  }
`
